import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { useEffect } from 'react';
import { useQuery } from '@tanstack/react-query';
import { Header } from './components/Header';
import { Footer } from './components/Footer';
import { WhatsAppButton } from './components/WhatsAppButton';
import { HomePage } from './pages/HomePage';
import { AboutPage } from './pages/AboutPage';
import { ServicesPage } from './pages/ServicesPage';
import { ServiceDetailPage } from './pages/ServiceDetailPage';
import { BlogPage } from './pages/BlogPage';
import { BlogPostPage } from './pages/BlogPostPage';
import { ContactPage } from './pages/ContactPage';
import { SitemapPage } from './pages/SitemapPage';
import { DynamicPage } from './pages/DynamicPage';
import { settingsApi } from './lib/api';
import { applyTheme, applyDefaultTheme, loadThemeFromStorage, type ThemeId } from './utils/theme';

function App() {
  const { data: settings } = useQuery({
    queryKey: ['public-settings'],
    queryFn: () => settingsApi.getPublic().then((res) => res.data),
    staleTime: 5 * 60 * 1000, // 5 dakika
    refetchOnMount: true,
  });

  // Sayfa yüklenirken localStorage'dan tema yükle (FOUC önleme)
  useEffect(() => {
    const savedTheme = loadThemeFromStorage();
    if (savedTheme) {
      applyTheme(savedTheme);
    }
  }, []);

  // API'den gelen tema ayarını uygula
  useEffect(() => {
    if (settings?.theme?.color) {
      const themeId = settings.theme.color as ThemeId;
      applyTheme(themeId);
    } else {
      // API'den tema gelmediyse localStorage'dan yükle, yoksa varsayılan
      const savedTheme = loadThemeFromStorage();
      if (savedTheme) {
        applyTheme(savedTheme);
      } else {
        applyDefaultTheme();
      }
    }
  }, [settings?.theme?.color]);

  return (
    <BrowserRouter>
      <div className="min-h-screen flex flex-col">
        <Header />
        <main className="flex-grow">
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/hakkimizda" element={<AboutPage />} />
            <Route path="/cozumler" element={<ServicesPage />} />
            <Route path="/cozumler/:slug" element={<ServiceDetailPage />} />
            <Route path="/blog" element={<BlogPage />} />
            <Route path="/blog/:slug" element={<BlogPostPage />} />
            <Route path="/iletisim" element={<ContactPage />} />
            <Route path="/sitemap.xml" element={<SitemapPage />} />
            {/* Dinamik sayfa route'u - tüm sayfalar için (en sonda olmalı) */}
            {/* Not: /yapay-zeka-otomasyonlar artık veritabanından yönetiliyor */}
            <Route path="/:slug" element={<DynamicPage />} />
          </Routes>
        </main>
        <Footer />
        <WhatsAppButton />
      </div>
    </BrowserRouter>
  );
}

export default App;

